// removed by extract-text-webpack-plugin
module.exports = {"Jumbotron":"_22Aq2-kF7oFQGQB7q81wRR","headingWrapper":"_3mWAnPTVc6KLA7oFA61FWu","heading":"_2zP4HIxrVnzvIuGLpHKjh9","underlining":"WMJpuVZZ5DKd_KJ98-6Pm","arrowBack":"_2j2evAJ8TDF2BW2B3gsJYK","bounce":"NPLFnmaGcNHHtqhsKSOV-","arrow":"_2VcJHUhy5F0wlBBpGrS0i4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Jumbotron/Jumbotron.stylesheet.css
// module id = 231
// module chunks = 0